import { InfoItem } from "../../../utils/utils";

const BillingDetailsCard = ({
    nextBillingDate,
    paymentMethod,
    planStarted,
    status,
}) => {

    const statusColor =
        status === true ? "#2ecc71" : "#ff5323";

    const statusDot =
        status === true ? "#2ecc71" : "#ff5323";

    return (
        <div
            className="bg-white rounded-[16px] border border-[#e4e5e7] overflow-hidden"
        >
            {/* HEADER */}
            <div
                className="px-[20px] py-[14px] border-b border-[#f0f1f3]"
            >
                <p className="font-semibold text-[15px] text-[#212326]">
                    Billing Details
                </p>
            </div>

            {/* BODY */}
            <div className="p-[20px]">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">

                    <InfoItem
                        label="Next billing date"
                        value={nextBillingDate}
                        valueClassName="font-semibold text-[14px] text-[#212326]"
                    />

                    <InfoItem
                        label="Payment method"
                        value={paymentMethod || "No card added yet"}
                        disabled={true}
                    />

                    <InfoItem
                        label="Plan started"
                        value={planStarted}
                        valueClassName="font-semibold text-[14px] text-[#212326]"
                    />

                    {/* STATUS */}
                    <div>
                        <p className="font-semibold text-[12px] text-[#9298a0] mb-[4px]">
                            Status
                        </p>

                        <div className="flex items-center gap-[6px]">
                            <div
                                className="w-[8px] h-[8px] rounded-full"
                                style={{ backgroundColor: statusDot }}
                            />

                            <p
                                className="font-semibold text-[14px]"
                                style={{ color: statusColor }}
                            >
                                {status ? "Active" : "Inactive"}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default BillingDetailsCard;